module.exports = __webpack_public_path__ + "media/country_flags/nu-fb115bcd.png";